// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m2rZ","title":"styles_title__3APad"};